export const rolesAccessList={
    owner:['owner','cityops','centralmanager','centralteam','centraldashboard','superadmin', "geoLocationEnabled", "onlyGeoUser"], //everything should be in lower case
    checklistSummary:['ins','receptionist', 'billing professional', 'ot staff', 'nursing staff', 'floor staff', 'rmo/cmo/duty doctor', 'rmo/cmo', 'lab staff', 'dietitian', 'insurance hospital', 'hospital doctor', 'duty doctor', 'admin', 'owner', 'anaesthetist', 'ot technician', 'tpa/billing', 'rmo'],
} 


//here the key should be the tab you want to add role authorised check and value should be the roles that can access that tab
//Key is taken from the url,if it is present then this check works
